import 'style-loader!./slide1.component.scss';
import { Component, OnInit, OnDestroy, ViewEncapsulation, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatIconRegistry, DateAdapter, MatDatepicker } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ReplaySubject } from 'rxjs';
import * as $ from 'jquery'
import { Status, Task, IKeyboard, Address, Copy, User } from 'app/theme/models/user.model';
import { IFindConsumerResponse, IConfirmationCodeResponse, IIsExistedResponse, IFindCFResponse, ICheckDeduplicateResponse, IResponseNormalizeAddress, IMergeCustomerResponse } from 'app/theme/models/response';
//Services 
import { CodiceFiscaleService } from 'app/theme/services/codiceFiscale.service'
import { UserService } from 'app/theme/services/user.service';
import { AlertService } from 'app/theme/services/alert.service';
import { ChannelService } from 'app/theme/services/channel.service';
import { LanguageService } from 'app/theme/services/language.service';
import { DataService } from 'app/theme/services/data.service';
import { AddressService } from 'app/theme/services/address.service';
import { CustomerService } from 'app/theme/services/customer.service';
import { EmailService } from 'app/theme/services/email.service';
import { CodeService } from 'app/theme/services/code.service';
import { CardService } from 'app/theme/services/card.service';
import { Router } from '@angular/router';
import { DialogService } from 'app/theme/services/dialog.service';
import { ThemeSpinnerService } from 'app/theme/services/themeSpinner.service';
import { ElementRef } from '@angular/core';

 
// MAT AUTOCOMPLETE
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
@Component({
	selector: 'reg-slide1',
	templateUrl: './slide1.component.html',
	encapsulation: ViewEncapsulation.None
})
export class ModuleComponent implements OnInit, OnDestroy {
	// IO
	@Output('hasAccount') hasAccount: EventEmitter<boolean> = new EventEmitter<boolean>(true);

	// User prop 
	user: User = new User();

	// Date Conditions 
	minDate: Date;
	maxDate: Date;
	DDN: Date;

	// Subsriptions 
	task: Task;
	Labels: any;
	alerts: any;
	phonePrefix: string;
	nexturl: string;
	// LOGIC
	customerPrepared: boolean;
	nonHoCF: boolean;
	nonHoCFDisabled: boolean;
	disableEmail: boolean;
	optionalHavingEmail: boolean;

	// pop up
	isOpenAddressList: boolean;
	isOpenCitiesList: boolean;
	isOpenProvinceList: boolean;
	isOpenStateList: boolean;
	isOpenNationalityList: boolean;
	isOpenPlaceOfBirhtList: boolean;

	//global variable
	idcustomer: string;

	Modificabile = {
		ModificabileNome: true,
		ModificabileCognome: true,
		ModificabileCF: true,
		ModificabileDDN: true,
		ModificabileNaionalita: true,
		ModificabileLuogoDiNascita: true,
		ModificabileSesso: true,
		ModificabileEmail: true
	}

	// MASK 'to be displayed'
	mask = {
		provinceDesc: '',
		stateDesc: '',
		nationalityDesc: '',
		cityDesc: '',
		palceOfBithDesc: ''
	}

	// CheckAddess  
	selectedAddess: boolean;
	oldQueryDocAddress: string = '';
	maxMatches: number;
	suggestedAddrNumber: number;

	//Regx 
	emaiRegx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/m);
	CapRegx = new RegExp(/^([0-9]{4,5})$/m);
	mobileRegx = new RegExp(/^([\d]{9,15})$/m);

	//Controllers
	placeOfBirthList: Array<any> = [];
	countriesList: Array<any> = [];
	provincesList: Array<any>
	italianCitiesList: Array<any> = [];

	mail: string = '';
 
	filteredStates: ReplaySubject<any> = new ReplaySubject<any>();
	filteredProvince: ReplaySubject<any> = new ReplaySubject<any>();
	filteredItalianCities: ReplaySubject<any> = new ReplaySubject<any>();
	filteredAddresses: ReplaySubject<Array<Address>> = new ReplaySubject<Array<Address>>();
	filteredlPlaceOfBirth: ReplaySubject<any> = new ReplaySubject<any>();
	filteredNationalities: ReplaySubject<any> = new ReplaySubject<any>();
	source: string;


	/** Subject that emits when the component has been destroyed. */
	constructor(
		protected adapter: DateAdapter<any>,
		protected router: Router,
		protected _userService: UserService,
		protected _dataService: DataService,
		protected _addressService: AddressService,
		protected _channelService: ChannelService,
		protected _alertService: AlertService,
		protected _langService: LanguageService,
		protected _cfService: CodiceFiscaleService,
		protected _customerService: CustomerService,
		protected _cardService: CardService,
		protected _emailService: EmailService,
		protected _codeServie: CodeService,
		protected _dialog: DialogService,
		protected _spinnerService: ThemeSpinnerService,
		iconReg: MatIconRegistry,
		sanitizer: DomSanitizer,
	) {
		iconReg.addSvgIcon("barcode", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_barcode_scanner.svg'))
		iconReg.addSvgIcon("phone", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_phone.svg'))
		iconReg.addSvgIcon("email", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_email.svg'))
		iconReg.addSvgIcon("delete", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_delete.svg'))
		iconReg.addSvgIcon("it_flag", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_flag_italian.svg'))
		iconReg.addSvgIcon("sw_flag", sanitizer.bypassSecurityTrustResourceUrl('./assets/icon/icon_flag_swiss.svg'))
	}
	ngOnDestroy() { }


    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE START
	hasexecuted = false
    ngAfterViewInit() {
        const fields = ['cap', 'city', 'province', 'address', 'civico','via','residence','palceOfBirth'];
        const disableForAll = this.source === 'tablet' || this.source === 'totem' || this.source === 'tablet-new' || this.source === 'totem-new';
        //console.log('Source:', this.source);
        if (disableForAll) {

            // Converte NodeList in un array e applica la funzione
            Array.from(document.querySelectorAll('input')).forEach((input: HTMLInputElement) => {
            this.disableAutocomplete(input.id); // Usa l'id se disponibile
            });
        
        } else {
            // Disattiva solo per i campi specificati
            fields.forEach(field => this.disableAutocomplete(field));
        }
        }
		ngAfterViewChecked() {
			const input = document.getElementById('palceOfBith') as HTMLInputElement; 
			if (input && !this.hasexecuted) { 
				this.hasexecuted = true
		
				const fields = ['cap', 'city', 'province', 'address', 'civico', 'via', 'residence', 'palceOfBith'];
				const disableForAll = this.source === 'tablet' || this.source === 'totem' || this.source === 'tablet-new' || this.source === 'totem-new';
			
				if (disableForAll) {
					// Disattiva autocomplete per tutti gli input
					Array.from(document.querySelectorAll('input')).forEach((input: HTMLInputElement) => {
						this.disableAutocomplete(input.id);
					});
				} else {
					// Disattiva autocomplete solo per i campi specificati
					fields.forEach(field => this.disableAutocomplete(field));
				}
			}
		}
		
    
        private disableAutocomplete(elementId: string): void {
            const inputElement = document.getElementById(elementId) as HTMLInputElement;
            let sottostringa = "mat-";        

            if (!elementId.toLowerCase().includes(sottostringa.toLowerCase())) {
                if (inputElement) {
                    // Disattiva tutti gli attributi legati all'autocomplete
                    inputElement.setAttribute('autocomplete', 'new-password'); // Alternativa più efficace a "off"
                    inputElement.setAttribute('autocorrect', 'off');
                    inputElement.setAttribute('autocapitalize', 'off');
                    inputElement.setAttribute('spellcheck', 'false');
                    
                    // Cambia dinamicamente il nome e l'ID per evitare suggerimenti memorizzati
                    const newName = elementId + '_' + new Date().getTime();
                    inputElement.setAttribute('name', newName);
                    inputElement.setAttribute('id', newName);
        
                    // Disattiva la gestione automatica degli indirizzi di Chrome e password manager
                    inputElement.setAttribute('data-lpignore', 'true'); // LastPass
                    inputElement.setAttribute('data-form-type', 'other');
                    inputElement.setAttribute('aria-autocomplete', 'none');
                
                    // Nasconde suggerimenti tramite CSS inline
                    // inputElement.style.setProperty('display', 'inline-block', 'important');
                    inputElement.style.setProperty('position', 'relative', 'important');
                    inputElement.style.setProperty('z-index', '9', 'important'); //Abbastanza da sovrapporre i campi non abbastanza da sovrapporre il resto
					
                    // Ritarda la modifica dell'ID per "ingannare" il browser
                    setTimeout(() => {
                        inputElement.setAttribute('id', elementId);
                    }, 1000);  
                }              
            }
        }  


		@ViewChild('mainContent') mainContent: ElementRef | null = null;
        skipToMain(event: Event) {
            event.preventDefault(); // Evita il comportamento predefinito del link
            
            if (this.mainContent) {
              setTimeout(() => {
                this.mainContent.nativeElement.focus();
              }, 0); // Timeout per garantire che Angular abbia reso l'elemento visibile
            }
          }
    //CR ACCESSIBILITà GESTIONE AUTOCOMPLETE END
	


	ngOnInit() {
		// initializing variables 
		var now = new Date();
		this.maxDate = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate())
		this.minDate = new Date(now.getFullYear() - 120, now.getMonth() + 1, now.getDay());
		this.nonHoCF = false;
		this.nonHoCFDisabled = false;
		this.disableEmail = false;
		this.customerPrepared = false;
		this.isOpenAddressList = false;
		this.isOpenCitiesList = true;
		this.optionalHavingEmail = false;
		this.maxMatches = 0;
		this.suggestedAddrNumber = 0;
		this.mail = '';
 		/*  Subscribtions */
		this._langService.translatePageIndex(4)
			.subscribe((mylabels) => {
				if (mylabels)
					this.Labels = mylabels;
			});
		this._userService.getUser()
			.subscribe((user) => {
				if (user) {
					this.user = Copy(user);
				}
			})

		this._userService.getPrefixNumber()
			.subscribe((prefix) => {
				if (prefix) {
					this.phonePrefix = prefix;
				}
			})

		this._langService.getUsedLanguage()
			.subscribe((lang) => {
				if (lang)
					switch (lang) {
						case 'ita': this.adapter.setLocale('ita'); break;
						case 'eng': this.adapter.setLocale('eng'); break;
						default: this.adapter.setLocale('ita'); break;
					}
			});
		this._langService.subscribeAlerts()
			.subscribe((alerts) => {
				if (alerts) {
					this.alerts = alerts;
				}
			})

		this._channelService.getSource()
			.subscribe((canale) => {
				if (canale)
					this.user.info.canale = canale;
			})

		this._channelService.getSource().subscribe((source: string) => {
			if (source) {
				this.source = source;
			}
		})

		this._channelService.getNextUrl()
			.subscribe((url) => {
				if (url)
					this.nexturl = url;
			})
		this._channelService.getTask()
			.subscribe((task: Task) => {
				if (task) {
					this.task = task;
					if (task == Task.RichiediBC)
						this.optionalHavingEmail = true;
					else
						this.openModule();
				}
			})

		$(".popup").on('click', (event) => {
			event.stopPropagation();
		})
		$(window).on('click', (event) => {
			this.isOpenAddressList = false;
			this.isOpenCitiesList = false;
			this.isOpenProvinceList = false;
			this.isOpenStateList = false;
			this.isOpenNationalityList = false;
			this.isOpenPlaceOfBirhtList = false;
		})
	}

	 
	createKeyboard() {
		if (this.user.info.canale == "totem") {
			require.ensure(['app/theme/assets/scripts/VirtualKeyboard.js'], require => {
				var virtualKeyboard = require('app/theme/assets/scripts/VirtualKeyboard.js');
				var keyboard1: IKeyboard = { options: {}, target: null, container: ".PageSlide1" };
				let vk = new virtualKeyboard.default(keyboard1);
				vk.init(".PageSlide1");
			});
		}
	}

	extractDateOfBirth() {
		// extract Date Of Birth 
		if (!this.user.info.cf) return "";
		var now = new Date();
		let day = this.user.info.cf.slice(9, 11);
		let month = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'].findIndex(month => month == this.user.info.cf[8].toUpperCase()) + 1;
		let year = this.user.info.cf.slice(6, 8)
		this.user.info.sesso = Number.parseInt(day) < 40 ? "M" : "F";
		day = this.user.info.sesso == "F" ? (Number.parseInt(day) - 40) + "" : day;
		let prefix = now.getFullYear() - Number.parseInt("19" + year) > 100 ? "20" : "19";

		return Number.parseInt(day) + "/" + month + "/" + prefix + year;
	}

	openModule() {

		this.customerPrepared = true;

		// hide the checkbox of cf 
		this.nonHoCFDisabled = true;
		// allow the address already inserted 
		this.selectedAddess = true;




		if (this.user.info.cf) {
			this.nonHoCF = false;
			this.Modificabile.ModificabileCF = false;
			this.user.info.dataDiNascita = this.extractDateOfBirth();

			this.onChangeDate(this.user.info.dataDiNascita, this.Labels.language);
			// extract Place Of Birth 
			let cfLDN = this.user.info.cf.slice(11, 15).toUpperCase();
			this.setPlaceOfBithFromFiscalCod(cfLDN);
		} else {
			this.nonHoCF = true;
			this.Modificabile.ModificabileCF = true;
		}

		switch (this.task) {
			case Task.RichiediBC:
				if (this.user.account.email) {
					this.user.contacts.email = this.user.account.email;
					this.disableEmail = true;
					this.Modificabile.ModificabileEmail = false;
					this.optionalHavingEmail = false;
					this.hasAccount.emit(true);
				}
				break;
			case Task.RegistratiSenzaBC:
				break;
			case Task.RegistratiConBC:
				break;
			default:
		}
		//console.log("log provincia : "+this.user.address.provincia);
		//console.log("log stato : "+this.user.address.stato);
		if (this.user.address.stato == "ITA") {
			this.nonHoCF = false;

			if (this.user.address.provincia) {
				//console.log("log provincia : "+this.user.address.provincia);
				this.getProvince(() => {
	                //DS questa modifica è stata inserita poichè in lettura dati DB vi è il codice provincia  mentre il metodo onSelectProvince si aspetta descrizione nazionalità
					if (this.user.address.provincia){
                        if (this.user.address.stato != "ITA") return;
                        var province = this.provincesList.find(prov => prov.codeProvincia == this.user.address.stato +"-"+this.user.address.provincia);
                        if (province) {    
                        this.onSelectProvince(province['descriptionProvincia']);
                        }
                    }
				})
			}
			if (this.user.address.localita)
				this.filteredItalianCities.next([this.user.address.localita]);
		}
		if (!this.user.address.stato && this.user.info.cf) {
			this.mask.stateDesc = 'ITALIA'
			this.user.address.stato = "ITA";
		}

		this.getCountries(() => {
			 //DS questa modifica è stata inserita poichè in lettura dati DB vi è il codice della nazionalità mentre il metodo onSelectNationality si aspetta descrizione nazionalità
			 if(this.user.info.nazionalita){
				var nationality = this.countriesList.find(nationality => nationality.code == this.user.info.nazionalita); 
				if (nationality) {
				 this.onSelectNationality(nationality.description);
				}
			}
			else {
				this.onSelectNationality("");
			}	
		//DS questa modifica è stata inserita poichè in lettura dati DB vi è il codice stato residenza  mentre il metodo onSelectResidance si aspetta descrizione nazionalità
		if(this.user.address.stato){
			var state = this.countriesList.find(state => state.code == this.user.address.stato); //CHANGED code to description
			if (state) {
				this.onSelectResidance(state.description);
			}
		}				
		else {
			this.onSelectResidance("");
		}

			this.getItalianCities(() => {
				let countries = this.countriesList.map(country => country.description);
				let italiaIndex = countries.findIndex(country => country == "ITALIA");
				countries.splice(italiaIndex, 1);
				this.placeOfBirthList.push(...countries);
				this.filteredlPlaceOfBirth.next([this.user.info.luogoDiNascita || ""]);
			});
		})
            
		// check of empty variables 
		if (this.user.info.nazionalita && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') this.Modificabile.ModificabileNaionalita = false;
		else this.Modificabile.ModificabileNaionalita = true;
		if (this.user.info.nome && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') this.Modificabile.ModificabileNome = false;
		else this.Modificabile.ModificabileNome = true;

		if (this.user.info.cognome && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') this.Modificabile.ModificabileCognome = false;
		else this.Modificabile.ModificabileCognome = true;

		if (this.user.info.cf && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') this.Modificabile.ModificabileCF = false;
		else this.Modificabile.ModificabileCF = true;

		if (this.user.info.sesso && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') this.Modificabile.ModificabileSesso = false;
		else this.Modificabile.ModificabileSesso = true;

		if (this.user.info.luogoDiNascita && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') {
			/* 
			Fix the bug of place of birth
			Uncomment part 1
			Comment part 2  
			*/

			// Start Part 1 
			/* if (this.getPlaceOfBith(this.user.info.luogoDiNascita)) {
				this.mask.palceOfBithDesc = this.user.info.luogoDiNascita ;
				this.Modificabile.ModificabileLuogoDiNascita = false;
			} else {
				this.mask.palceOfBithDesc = '';
				this.user.info.luogoDiNascita = '';
				this.Modificabile.ModificabileLuogoDiNascita = true;
			}  */
			// End Part 1 

			// Start Part 2
			this.Modificabile.ModificabileLuogoDiNascita = false;
			this.mask.palceOfBithDesc = this.user.info.luogoDiNascita;
			// End Part 2
		}
		else this.Modificabile.ModificabileLuogoDiNascita = true;

		if (this.user.info.dataDiNascita && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R') this.Modificabile.ModificabileDDN = false;
		else this.Modificabile.ModificabileDDN = true;
		if (!this.phonePrefix) {
			this._userService.setPrefixNumber("+39")
		}
		if (this.user.address.localita)
			this.mask.cityDesc = this.user.address.localita;

		// hide the popup lists 
		this.isOpenAddressList = false;
		this.isOpenCitiesList = false;

		setTimeout(() => { this.createKeyboard(); }, 0);
	}

	setPlaceOfBithFromFiscalCod(cfCode) {
		let setFromWorld = () => {
			let Country = this.countriesList.find(country => {
				return country.cfCode == cfCode
			});
			if (Country) {
				this.user.info.luogoDiNascita = Country.description;
				this.mask.palceOfBithDesc = Country.description;
				this.Modificabile.ModificabileLuogoDiNascita = false;
				return true;
			}
			return false;
		}

		let setFromItaly = () => {
			for (var city of this.italianCitiesList) {
				if (city.cfCode == cfCode) {
					this.user.info.luogoDiNascita = city.description;
					this.mask.palceOfBithDesc = city.description;
					this.Modificabile.ModificabileLuogoDiNascita = false;
				}
			}
		}
		this.getCountries(() => {
			if (!setFromWorld())
				this.getItalianCities(() => {
					setFromItaly();
				});
		});
	}
	checkStringReg(target: string, el?: Element) {

		var value = $(el).val();
		var rS = /[^a-zìéèçòàù ']/gi;
		 

		if ((value + "").length > 0) {
			setTimeout(() => {
				if (target == "nome") {
					var replaceString = (value + "").replace(rS, "");
					$(el).val(replaceString);
					this.user.info.nome = replaceString;

				}
				if (target == "cognome") {
					var replaceString = (value + "").replace(rS, "");
					$(el).val(replaceString);
					this.user.info.cognome = replaceString;
				}
				

			}, 0);
		}
	}
	getPlaceOfBith(luogoDiNascita: string) {
		let getFromWorld = () => {
			let Country = this.countriesList.find(country => country.description.toUpperCase() == luogoDiNascita);
			if (Country) {
				//console.log("Country : "+luogoDiNascita);
				if (luogoDiNascita == 'ITALIA')
					cfCode = 'XX';
				else
					cfCode = Country.cfCode;
				return true;
			} else if (luogoDiNascita && this.user.address.stato != "ITA") {   //else if aggiunto per xxx cf fiscale
				//console.log("luogo di nascita : "+luogoDiNascita);
				cfCode = 'XX';
				return true;
			}
			//console.log("getFromWorld : "+luogoDiNascita);
			return false;

		}
		let getFromItaly = () => {
			for (var city of this.italianCitiesList) {
				if (city.description == luogoDiNascita) {
					cfCode = city.cfCode;
					return true;
				}
			}
			//	console.log("getFromItaly : "+luogoDiNascita);
			// aggiunto in modo che gestisca l'utente residente in italia ma mette un luogo di nascita errato da quello indicato nel CF 
			if (this.user.address.stato == "ITA")
				cfCode = 'XX';
			return false;
		}

		let cfCode = "";
		this.getCountries(() => {
			if (!getFromWorld())
				this.getItalianCities(() => {
					getFromItaly();
				});
		});
		return cfCode;
	}

	getCountries(callback?) {
		if (this.countriesList.length != 0) {
			if (callback)
				callback();
		}
		else
			this._dataService.GetListLKCountry()
				.subscribe((Countries: Array<any>) => {
					if (Countries) {
						if (this.countriesList.length == 0) {
							this.countriesList.push(...Countries);
							this.filteredStates.next(Countries);
							this.filteredNationalities.next(Countries);
						}
						if (callback)
							callback();
					}
				})
	}

	getProvince(callback?) {
		if (this.provincesList) {
			if (callback)
				callback();
		}
		else
			this._dataService.GetListProvincia()
				.subscribe((provs: Array<any>) => {
					if (provs) {
						this.provincesList = provs;
						this.filteredProvince.next(this.provincesList);
						if (callback)
							callback();
					}
				})
	}

	getItalianCities(callback?) {
		if (this.italianCitiesList.length != 0) {
			if (callback)
				callback();
		}
		else
			this._dataService.GetItalianCities()
				.subscribe((Cities: Array<any>) => {
					if (Cities) {
						if (this.italianCitiesList.length == 0) {
							this.italianCitiesList = Cities;
							this.italianCitiesList.forEach(city => {
								this.placeOfBirthList.push(city.description)
							})
						}
						if (callback)
							callback();
					}
				})
	}
	isPreparedCustomer() {
		const { nome, cognome, cf, dataDiNascita } = this.user.info;
		return (nome && cognome && (dataDiNascita || cf)) ? true : false
	}

	findConsumer(): Promise<any> {
		if (!this.nonHoCF) {
			this.user.info.dataDiNascita = this.extractDateOfBirth();
		}
		const { nome, cognome, dataDiNascita, cf } = this.user.info;

		return new Promise((resolve, reject) => {
			this._customerService.FindConsumer(nome, cognome, dataDiNascita, cf, "")
				.then((data: IFindConsumerResponse) => {
					//	console.log("tentativo rowid : "+data.rowIdCustomer);
					if (data.rowIdCustomer){
						this._userService.customerid = data.rowIdCustomer;
					}
 					if (data.key){
						this._userService.key=data.key;

					}
					if (data.cardValida.toUpperCase() == "Y"){
					this._userService.codTesseraFind=data.codTessera;
					}
 					if (data.cardValida.toUpperCase() == "Y" && this.task !== Task.RegistratiConBC)
						return reject({ type: "action", title: this.Labels.retrive + " BENNET CLUB", content: this.alerts.alert_11, redirect: null, btn: this.Labels.retrive })
					if (this.task != Task.RichiediBC && data.username && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R')
						return reject({ type: "action", title: "Login", messsage: this.alerts.alert_15 + " <mark>" + data.username + "</mark>", redirect: "pages/home", btn: "Login" });
					if (this.task == Task.RichiediBC && data.rowIdCustomer)
						this._cardService.GetCustomerListTessere("", data.rowIdCustomer,data.key)
							.then((list: Array<any>) => {
								if (list.length != 0)
									return reject({ type: "action", title: this.Labels.retrive + " BENNEt CLUB", content: this.alerts.alert_11, redirect: null, btn: this.Labels.retrive });
								return resolve(data);
							})
							.catch((error) => {
								if(this.source=='app'){
									//console.log("chiamata script KO getCustomerListTesser");
									self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
								}
								return reject({ type: error.type, title: "Server", content: this.alerts.alert_32, btn: this.Labels.try })
							})
					return resolve(data);
				})
				.catch((error) => {
					if(this.source=='app'){
						//console.log("chiamata script KO FindConsumer");
						self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
					}
					return reject({ type: error.type, title: "Server", content: this.alerts.alert_32, btn: this.Labels.try })
				})
		})
	}


	onPrefixChange() {
		this._userService.setPrefixNumber(this.phonePrefix ? (this.phonePrefix) : "");
	}

	checkLength(control: string, el?: Element) {
		var value = $(el).val();
		if (control == "cap") {
			setTimeout(() => {
				if (value) {
					if ((value + "").length > 4) {
						let cap5 = (value + "").slice(0, 5);
						if (el) {
							$(el).val(cap5);
							this.user.address.cap = cap5;
						}
					}
				}
			}, 0);
		}
		if (control == "cf") {
			if (value) {
				setTimeout(() => {


					if ((value + "").length > 15) {
						let cf16 = (value + "").slice(0, 16);
						if (el) {
							$(el).val(cf16);
							this.user.info.cf = cf16;
						}
					}
				}, 0);
			}
		}
		if (control == "cellulare") {
			if (value) {
				setTimeout(() => {


					if ((value + "").length > 14) {
						let cellulare15 = (value + "").slice(0, 15);
						if (el) {
							$(el).val(cellulare15);
							this.user.contacts.cellulare = cellulare15;
						}
					}
				}, 0);
			}
		}
	}
	// After Select 
	onSelectNationality(code) {
        this.isOpenNationalityList = false;
        var nationality = this.countriesList.find(nationality => nationality.description == code);//CHANGED code to description
		if (nationality) {
			this.user.info.nazionalita = nationality.code;
			this.mask.nationalityDesc = nationality.description;
		}
	}
	onSelectPlaceOfBirth(placeOfBirth) {
		this.isOpenPlaceOfBirhtList = false;
		this.user.info.luogoDiNascita = placeOfBirth
		this.mask.palceOfBithDesc = placeOfBirth;
	}
	onSelectResidance(code, reset = false) {
		this.isOpenStateList = false;
        var state = this.countriesList.find(state => state.description == code); //CHANGED code to description
		if (state) {
			this.mask.stateDesc = state.description;
			this.user.address.stato = state.code;
			if (state.code == "ITA") {
				this.nonHoCF = false;
				if (!this.provincesList)
					this.getProvince();
				if (reset) {
					this.filteredProvince.next([])
					this.mask.provinceDesc = '';
					this.user.address.provincia = ''
				}
			}
			else {
				this.nonHoCF = true;
				this.mask.provinceDesc = "NON PRESENTE";
				this.user.address.provincia = this.user.address.stato + "-NP";
			}
			if (reset) {
				this.filteredItalianCities.next([])
				this.onSelectCity('')
			}
		}
	}
	onSelectProvince(codice: string, reset = false) {
		this.isOpenProvinceList = false;
        //if (!codice.includes("ITA")) codice = "ITA-" + codice; REMOVED TO NOT DO ITA-NAPOLI
        var province = this.provincesList.find(prov => prov.descriptionProvincia == codice);
		if (province) {
			this.user.address.provincia = province['codeProvincia'];
			this.mask.provinceDesc = province['descriptionProvincia'];
			if (reset) {
				this.filteredItalianCities.next([])
				this.onSelectCity('');
			}
		}
	}
	onSelectCity(city) {
		if (this.user.address.stato != "ITA")
			return;
		this.isOpenCitiesList = false;
		this.user.address.localita = city;
		this.mask.cityDesc = city;
		this.user.address.via = ''
		this.user.address.cap = ''
		this.user.address.civico = ''
	}

	onSelectAddress(via) {
		this.isOpenAddressList = false;
		this.selectedAddess = true;
		this.user.address.via = via;
		this.normalizeAddress(true);
	}

	normalizeAddress(forced, callback?) {
		if (this.user.address.stato == "ITA")
			this._addressService.NormalizeAddress(this.user.address)
				.then((data: IResponseNormalizeAddress) => {
					data.resultCode += '';
					switch (data.resultCode) {
						case '8':
						case '9':
						case '4':
							this.user.address.localita= data.localita;
							this.user.address.via = data.via;
							this.user.address.cap = data.cap;
							this.user.address.civico = data.civico
							this.user.address.latitudine = data.lant;
							this.user.address.longitudine = data.longi;
							this.user.address.istatComunale = data.istatComunale;
							this.user.address.istatRegionale = data.istatRegionale;
							this.user.address.sezioneCensimento = data.sezioneCensimento;
							break;
						case '10':
							this.user.address.localita= data.localita;
							this.user.address.latitudine = '';
							this.user.address.longitudine = '';
							this.user.address.istatComunale = '';
							this.user.address.istatRegionale = '';
							this.user.address.sezioneCensimento = '';
							if (forced) this.user.address.cap = data.cap;
							break;
					}
					this.user.address.resultCode = data.resultCode;
					if (callback) callback();
				})
				.catch((error) => {
					console.error(error);
					if (callback) callback();
				});
		else
			if (callback) callback()
	}
	onWritingNationality() {
		this.user.info.nazionalita = ''
		this.isOpenNationalityList = true;
		var nationalities = this.countriesList.filter(state => state.description.toLowerCase().indexOf(this.mask.nationalityDesc.toLowerCase()) == 0) || [];
		this.filteredNationalities.next(nationalities);
	}
	/*	onWritingPlaceOfBirth() {
			this.user.info.luogoDiNascita = ''
			if (this.mask.palceOfBithDesc.length > 1) {
				this.isOpenPlaceOfBirhtList = true;
				var places = this.placeOfBirthList.filter(palce => palce.toLowerCase().indexOf(this.mask.palceOfBithDesc.toLowerCase()) == 0) || [];
				if (places) {
					this.filteredlPlaceOfBirth.next(places);
				}
			}
		}*/
	onWritingPlaceOfBirth() {
		this.user.info.luogoDiNascita = ''
		if (this.mask.palceOfBithDesc.length > 1) {
			this.isOpenPlaceOfBirhtList = true;
			var places = this.placeOfBirthList.filter(palce => palce.toLowerCase().indexOf(this.mask.palceOfBithDesc.toLowerCase()) == 0) || [];
			if (places) {
				this.filteredlPlaceOfBirth.next(places);
			}
			this.user.info.luogoDiNascita = this.mask.palceOfBithDesc;
			/*	if(this.placeOfBirthList.indexOf(this.user.info.luogoDiNascita.toUpperCase()) > -1)
					console.info("luogo nascita inserito, presente nella lista "+this.user.info.luogoDiNascita );
				else
				console.info("luogo nascita inserito non esistente nella lista"+this.user.info.luogoDiNascita );
		*/
		}
	}
	onWritingResidance() {
		this.isOpenStateList = true;
		var states = this.countriesList.filter(state => state.description.toLowerCase().indexOf(this.mask.stateDesc.toLowerCase()) == 0) || [];
		this.filteredStates.next(states);
	}
	onWritingProvince() {
		this.isOpenProvinceList = true;
		var provs = this.provincesList.filter(prov => prov.descriptionProvincia.toLowerCase().indexOf(this.mask.provinceDesc.toLowerCase()) == 0) || [];
		this.filteredProvince.next(provs)
	}
	onWritingCity() {
		const { stato, provincia } = this.user.address
		if (stato != "ITA") {
			this.user.address.localita = this.mask.cityDesc
			return;
		}
		if (!provincia || this.mask.cityDesc.length < 3) {
			return;
		}
		this.user.address.localita = ''
		this.user.address.via = ''
        this.user.address.cap = ''
        this.user.address.civico = ''
		var prov = provincia.replace("ITA-", "");
		this._addressService.GetItalianCitiesofProvinceJAKALA(stato, prov, this.mask.cityDesc)
			.then((cities: Array<any>) => {
				if (cities) {
					var search = this.mask.cityDesc.toLowerCase();
					this.isOpenCitiesList = true;
					cities = cities.filter(city => city.toLowerCase(city).includes(search))
					cities = cities.sort((c1, c2) => c1.toLowerCase().indexOf(search) - c2.toLowerCase().indexOf(search))
					this.filteredItalianCities.next(cities);
				}
			})
			.catch((error) => {
				let refDialog = this._alertService.showModalConfirm('', 'Servizio momentaneamente non disponibile , vi invitiamo a riprovare', 'OK', 'X')
				/* modifica per uniformare ok alla x del popup
					refDialog.result
					.then(data => {
						if (this.user.info.canale == 'totem' || this.user.info.canale == 'tablet')
							window.location.replace(decodeURIComponent(window.location.href));
						else if (this.user.info.canale == 'totem-new' || this.user.info.canale == 'tablet-new')
							window.top.location.href = decodeURIComponent(window.location.href);
						else if (this.user.info.canale == 'drive-new' || this.user.info.canale == 'bennet-new')
							window.top.location.href = decodeURIComponent(this.nexturl);
						else {
							window.location.replace(decodeURIComponent(this.nexturl));
						}
					})
					.catch(data => {
						//modifica
						if (this.user.info.canale == 'totem' || this.user.info.canale == 'tablet')
						window.location.replace(decodeURIComponent(window.location.href));
					else if (this.user.info.canale == 'totem-new' || this.user.info.canale == 'tablet-new')
						window.top.location.href = decodeURIComponent(window.location.href);
					else if (this.user.info.canale == 'drive-new' || this.user.info.canale == 'bennet-new')
						window.top.location.href = decodeURIComponent(this.nexturl);
					else {
						window.location.replace(decodeURIComponent(this.nexturl));
					}
					})*/

			});
		//.catch((error => console.error(error)));
	}
	onWritingAddress() {
		this.selectedAddess = false;
		var { stato, localita, provincia, via } = this.user.address;
		var street = (via + "").toLowerCase().trim();
		if (stato != "ITA" || !localita || !provincia || !street || 'via'.includes(street) || 'corso'.includes(street) || 'piazza'.includes(street)) return;
		street = street.replace(/via |corso /gi, '');
		this._addressService.VerifyStreet(this.user.address)
			.then((streets: Array<any>) => {
				streets = streets.filter(s => s.toLowerCase().includes(street.toLowerCase()))
				streets = streets.sort((s1, s2) => s1.toLowerCase().indexOf(street.toLowerCase()) - s2.toLowerCase().indexOf(street.toLowerCase()));
				this.filteredAddresses.next(streets);
				this.isOpenAddressList = true;
				this.suggestedAddrNumber = streets.length;
			})
			.catch((error) => {
				console.warn("service address doctor is not available  !")
			})
	}

	onChangeDate(ddn, lang = this.Labels.language) {
		if (!ddn) return;
		var date = ddn.split('/');
		var anno = date[2];
		var mese = lang == "english" ? Number(date[0]) : Number(date[1]);
		var giorno = lang == "english" ? Number(date[1]) : Number(date[0]);
		this.DDN = new Date(Number(anno), Number(mese) - 1, Number(giorno))
		this.user.info.dataDiNascita = (Number(giorno) > 9 ? giorno : ('0' + giorno)) + "/" + (Number(mese) > 9 ? mese : ('0' + mese)) + "/" + anno;
	}
	openDatePicker(datepickerBtn: MatDatepicker<Date>) {
		datepickerBtn.open();
	}
	calculateFodiceFiscale(): any {
		let codiceLDB = this.getPlaceOfBith(this.user.info.luogoDiNascita.toUpperCase());
		let DOB = this.user.info.dataDiNascita.split('/');
		this._cfService.GLuogoDiNascita(codiceLDB);
		this._cfService.GNome(this.user.info.nome.toUpperCase());
		this._cfService.GCognome(this.user.info.cognome.toUpperCase())
		this._cfService.GAnno(Number(DOB[2]))
		this._cfService.GMese(Number(DOB[1]))
		this._cfService.GGiorno(Number(DOB[0]), this.user.info.sesso);
		return this._cfService.generateCF();
	}

	areEquals(str1, str2): boolean {
		let s1 = str1 ? ((str1 + "").trim() + "").toLowerCase() : "";
		let s2 = str2 ? ((str2 + "").trim() + "").toLowerCase() : "";
		return s1 == s2;
	}
	private scrollToMissingPart(target) {
		var targetInput = $(target);
		if ($(targetInput[0]).offset()) {
			var top = $(targetInput[0]).offset().top;
			var currentScrollBody = $("body").scrollTop();
			if (top < 30) {
				$("body").scrollTop(currentScrollBody + top - 30);
			}
			else {
				if (top > 35) {
					$("body").scrollTop(top - 30 - currentScrollBody);
				}
			}
		}
	}
	replaceWith(content: string, replacedWith: string): string {
		return content.replace("XXXX", "<strong>" + replacedWith + "</strong>");
	}
	findMissingField() {
		let that = this;
		var missing = 0;
		var mux = 0;
		
		if (!this.user.info.nazionalita) $("#nationality").val("");
		if (!this.user.info.luogoDiNascita) $("#palceOfBith").val("");
		$(".hint").removeClass("show");
		
		$('.PageSlide1').find('.field').each(function () {
			let input = $(this).find('input');
			let matSelect = $(this).find('.mat-select');
			
			if (input.length && input.prop('required')) {
				if (input.val().toString().trim() === "" && !input.prop('disabled')) {
					$(this).find(".hint").addClass("show");
					input.addClass("input-error"); // Aggiunge bordo all'input
					missing++;
					if (mux === 0) {
						mux = 1;
						that.scrollToMissingPart($(this));
					}
				} else {
					$(this).find(".hint").removeClass("show");
					input.removeClass("input-error"); // Rimuove bordo dall'input
				}
			}
			
			if (matSelect.length && matSelect.attr('aria-required') === 'true') {
				let selectedValue = matSelect.find('.mat-select-value').text().trim();
				if (selectedValue === "" && !matSelect.prop('disabled')) {
					$(this).find(".hint").addClass("show");
					matSelect.addClass("input-error"); // Aggiunge bordo al mat-select
					missing++;
					if (mux === 0) {
						mux = 1;
						that.scrollToMissingPart($(this));
					}
				} else {
					$(this).find(".hint").removeClass("show");
					matSelect.removeClass("input-error"); // Rimuove bordo dal mat-select
				}
			}
		});
		
		$('.PageSlide1').find(".missing").each(function () {
			$(this).siblings(".hint").addClass("show");
			$(this).addClass("input-error");
			missing++;
			if (mux === 0) {
				mux = 1;
				that.scrollToMissingPart($(this));
			}
		});
		
		$('.PageSlide1').find(".existed").each(function () {
			$(this).siblings(".hint").removeClass("show");
			$(this).removeClass("input-error");
		});
		
		if (missing != 0) {
			$(".updateAccountPage").scrollTop(0);
		}
		
		return missing;
	}
	

	onModuleSubmit() {
		return new Promise((resolve, reject) => {
			//console.log("prova"+this.customerPrepared);
		//console.log("prova"+this.user.info.codTessera);
		//console.log("prova"+this.task);
			//console.log("onModuleSubmit");
			this.basicController(() => {

				/*if (this.user.info.cf) {
					this.nonHoCF = false;
				}*/
				//console.log("basicController");
				//debugger;
				
				this.normalizeCustomer(() => {
					//console.log("normalizeCustomer");
					this.normalizeVerifyEmail(() => {
						//console.log("normalizeVerifyEmail");
						this.verifyPhone(() => {
							this._codeServie.SendCodeRequest(this.user.contacts.email, this.phonePrefix + this.user.contacts.cellulare, this.user.info.canale)
								.then((data: IConfirmationCodeResponse) => {
									if (data.success) {
										if (this.disableEmail || this.user.account.email)
											this.hasAccount.emit(true);
										else
											this.hasAccount.emit(false);
										if (this.user.address.stato != 'ITA') {
											this.user.address.sezioneCensimento = '';
											this.user.address.istatComunale = '';
											this.user.address.istatRegionale = '';
											this.user.address.longitudine = '';
											this.user.address.latitudine = '';
											this.user.address.resultCode = '';
										}
										this.normalizeAddress(false, () => {
											this._userService.setUser(this.user);
											return resolve();
										})
									} else {
										reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32 })
									}
								})
								.catch((error) => {
									if(this.source=='app'){
										//console.log("chiamata script KO Confirmation code");
										self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
									}
									reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32 })
								})
						}, (message) => {
							//debugger;
							return reject(message)
						})
					}, (message) => {
						//debugger;
						return reject(message)
					})
				}, (message) => {
					//debugger;
					return reject(message)
				})
			}, (message) => {
				//debugger;
				return reject(message)
			})
		})
	}

	basicController(resolve, reject) {
		//debugger;
		var { info, address, contacts } = this.user;
		// check if the  name or surname longer than 30 chars .
		if (this.user.info.nome.length > 30 || this.user.info.cognome.length > 30) {
			return reject({ type: "message", title: "", content: this.alerts.alert_41, btn: 'X' });
		}
		// check if any missing fields existed .
		if (this.findMissingField() != 0) {
			return reject({ type: "pre-checking", content: "Missing required fields" });
		}
		if (!this.nonHoCF) {
			// heck if the format of CF correct 
			/*if (!this._cfService.isValidCF(this.user.info.cf))
				return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_40, this.user.info.cf), btn: 'X' });
			*/
			if (!this._cfService.isValidCF(this.user.info.cf))
				return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.alerts.alert_5, btn: 'X' });

			// console.log("formato codice fiscale corretto");
			var now = new Date();
			let day = this.user.info.cf.slice(9, 11);
			let month = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'].findIndex(month => month == this.user.info.cf[8].toUpperCase()) + 1;
			let year = this.user.info.cf.slice(6, 8)
			 
			day = Number.parseInt(day) < 40 ? day : (Number.parseInt(day) - 40) + ""  ;
			let prefix = now.getFullYear() - Number.parseInt("19" + year) > 100 ? "20" : "19";
			 
			 
			 let dn_test=new Date(Number(prefix + year), Number(month) - 1, Number(day))
			  //console.log( "log data nascita REG"+ this.maxDate +" <"+dn_test+( (this.maxDate < dn_test) ? " VERO" : "FALSo"));
			  if (this.maxDate < dn_test) {
				return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.alerts.alert_44, btn: 'X' });
			}
		
		}
		if (!this.customerPrepared) {
			if (!this.nonHoCF) {
				let temp = '-1';
				// check if cf  exists 
				//return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_5, this.user.info.cf), btn: 'X' });
				// check if name and surname compatible with the inserted info
				return this._customerService.FindCF(this.user.info.cf)
					.then((data: IFindCFResponse) => {
						if (data.exist)
							return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_2, this.user.info.cf), btn: 'X' });
						else {
							this._cfService.GCognome(info.cognome);
							this._cfService.GNome(info.nome);
							let gcf = this._cfService.getCFGenerated();
							let CF1 = (gcf._cognome + gcf._nome).toUpperCase();
							let CF2 = info.cf.slice(0, 6).toUpperCase();
							//console.log("CF1 : "+CF1+" CF2 : "+CF2 );
							if (CF1 != CF2) {
								//console.log("CF1 diverso da CF2 " );
								return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_5, this.user.info.cf), btn: 'X' });
							}
							return resolve(data);
						}
						//temp = '1';
					})
					.catch(() => {
						if(this.source=='app'){
							//console.log("chiamata script KO FindCF");
							self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
						}
						return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
					})
				//console.log("valore temp "+temp)
			/*	if (temp == '1')
					return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_2, this.user.info.cf), btn: 'X' });
			*/	

			}else{
				return resolve();
			}

		} else {
			//	console.log("dentro else CF" );
			// check if CF compatible with the inserted info
			if (address.stato == "ITA") {
				//console.log("dentro else CF  ITA " );
				let data = this.calculateFodiceFiscale()
				//console.log("calculateFodiceFiscale : "+data)
				if (data.error)
					return reject(data.error);
				else {
					let CF1 = data.cf.toUpperCase();
					let CF2 = this.user.info.cf.slice(0, this.user.info.cf.length - 1).toUpperCase();
					//console.log("CF1 : "+CF1);
					//console.log("CF2 : "+CF2);
					if (CF1 != CF2)
						return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.alerts.alert_5, btn: 'X' });
					//return reject({ type: "message", title: this.Labels.control_inserted_fields, content: data.error, btn: 'X' });
				}
			}
			// check if format of CAP is correct 
			if (!this.CapRegx.test(address.cap))
				return reject({ type: "message", title: "CAP", content: this.alerts.alert_12, brn: 'X' });
			// check if length of CAP is correct 
			if (address.cap.length > 5)
				return reject({ type: "message", title: "CAP", content: this.alerts.alert_34, brn: 'X' });
			// check if length of House number is correct 
			if (address.civico.length > 6)
				return reject({ type: "message", title: "", content: this.alerts.alert_39, brn: 'X' });
			// check if format of mobile is correct 
			if (!this.mobileRegx.test(contacts.cellulare))
				return reject({ type: "message", title: this.Labels.invalid, content: this.replaceWith(this.alerts.alert_6, contacts.cellulare), btn: 'X' })
			// check if format of email is correct 
			if (!this.disableEmail)
				if (!this.emaiRegx.test(this.user.contacts.email))
					return reject({ type: "message", title: "E-mail", content: this.replaceWith(this.alerts.alert_4, this.user.contacts.email), btn: 'X' });
			// check if  address is correct 
			/*if (!this.selectedAddess && this.user.address.stato == "ITA")
				return reject({ type: "message", title: "Dato Obbligatorio", content: this.alerts.alert_38, btn: 'X' });
			*/
			if(this.nonHoCF)
				return resolve();
			else {
				return this._customerService.FindCFExt(this.user.info.cf, this._userService.customerid)
					.then((data: IFindCFResponse) => {
						if (!data.exist)
							return resolve(data);
						else
							return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_2, this.user.info.cf), btn: 'X' });
						//temp = '1';
					})
					.catch(() => {
						if(this.source=='app'){
							//console.log("chiamata script KO FindCFext");
							self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
						}
						return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
					})
			} 

			
		}

		//	return resolve()
	}

	normalizeCustomer(resolve, reject) {
		//	console.log("normalizeCustomer");
		//	console.log("l'utente e anonimo")
		 
		if (!this.customerPrepared) {
			// check if customer existed or not 
			this.findConsumer()
				.then((data) => {
					//debugger;
					//if (data.username || data.rowIdCustomer)
					if ((data.username || data.rowIdCustomer) && data.anonimo != 'Y')
						this._customerService.GetInfoUser(data.rowIdCustomer, "","",data.key)
							.then((UserInfo) => {
								this._userService.resetUser(UserInfo);
							})
							.catch(() => {
								if(this.source=='app'){
									//console.log("chiamata script KO GetInfoUser");
									self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
								}
								return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32 })
							})
					//valorizzo la variabile globale idcustomer
					this.idcustomer = data.rowIdCustomer;
					//console.log("idcustomer : " + this.idcustomer);

					this.openModule();
					return reject({ type: "pre-checking", content: "prepare customer" });

				}).catch((error) => {
					return reject(error)
				})
		} else {
				//debugger;
				this.user.info.anonimo
				//console.log("idcustomer else : "+this.idcustomer);
			//if (this.task == Task.RegistratiConBC){
			if (this.task == Task.RegistratiConBC && this.user.info.anonimo != 'Y' && this.user.info.anonimo != 'R')
				return resolve()
			let cardMaster = null;
			//verificare se l'utente è registrato
			let usernameData = "";
			this.findConsumer()
				.then((dato) => {

					if (this.user.info.anonimo == 'Y' || this.user.info.anonimo == 'R') {
						if (dato.rowIdCustomer) {
							if (dato.username) {
								//console.log("username utente dentro if : "+dato.username);
								this.mail = dato.username; let Index = dato.username.indexOf('@');
								usernameData = dato.username.slice(0, 2) + 'XXXX' + dato.username.slice(Index, dato.username.length);
								this.user.info.anonimo = 'R';

							}
							this.idcustomer = dato.rowIdCustomer;
							//console.log("idcustomer else : "+this.idcustomer);
							//console.log("username utente : "+usernameData)
							//fine verifica						
							this._spinnerService.hide();
							cardMaster = dato.codTessera;
							const ref = this._dialog.openAnonimoDialog({
								title: this.alerts.alert_43,
								content: this.user.info.codTessera,
								codTessera: dato.codTessera,
								username: usernameData,
								action: [{ label: "Esci", value: 0, class: "danger" }, { label: "Avanti", value: 1, class: "success" }]
							})
							ref.afterClosed().subscribe((value) => {
								this._spinnerService.show();
								if (this.user.info.anonimo == 'R') {
									if (value === undefined || value == 0) {
										window.top.location.href = decodeURIComponent(this.nexturl);
									} else if (value == 1) {
										return this._customerService.MergeCust(this.user.info.codTessera, cardMaster, dato.rowIdCustomer, dato.key)
											.then((data: IMergeCustomerResponse) => {
												if (data.exist)
													window.top.location.href = decodeURIComponent(this.nexturl);
												else
													return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
												//window.top.location.href = decodeURIComponent(this.nexturl);
											})
											.catch(() => {
												if (this.source == 'app') {
													//console.log("chiamata script KO MergeCustomer");
													self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
												}
												return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
											})
									}
								} else {
									if (value == 1)
										resolve()
									else
										window.top.location.href = decodeURIComponent(this.nexturl);

									//reject({ type: "anonimo", title: this.Labels.worning, content: this.alerts.alert_15, btn: this.Labels.exit })
								}

								/*if (value == 1)
									resolve()
								else
									reject({ type: "anonimo", title: this.Labels.worning, content: this.alerts.alert_15, btn: this.Labels.exit })
								*/
							})
						}
						else resolve()
					}
					else {
						//console.log("chiamata find consumer");
						return dato.cardValida=='Y' ?
							reject({ type: "message", title: this.Labels.worning, content: this.alerts.alert_15, btn: 'X' })
							: resolve()
					}
				}).catch(() => {
					if(this.source=='app'){
						//console.log("chiamata script KO CheckDeduplicate");
						self.postMessage(JSON.stringify({"type": "KO", payload: {"username": "", "password": "", "message":this.alerts.alert_32}}),'*');
					}
					return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
				})







		}
	}

	normalizeCF(resolve, reject) {
		//	console.log("normalizeCF");

		if (this.nonHoCF)
			return resolve();
		if (this.task == Task.RegistratiConBC)
			return resolve();
		// check if the customer has unique cf  
		this._customerService.FindCF(this.user.info.cf)
			.then((data: IFindCFResponse) => {
				if (!data.exist || (data.exist && this.user.account.email))
					return resolve(data);
				else
					return reject({ type: "message", title: this.Labels.control_inserted_fields, content: this.replaceWith(this.alerts.alert_2, this.user.info.cf), btn: 'X' })
			})
			.catch(() => {
				if (this.source == 'app') {
					//console.log("chiamata script KO FindCF");
					self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
				}
				return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
			})
	}

	normalizeVerifyEmail(resolve, reject) {
		//	console.log("normalizeVerifyEmail");
		if (this.mail === (this.user.contacts.email).toUpperCase())
			return resolve();
		if (this.disableEmail) {
			this.user.contacts.emailStatus = Status.NONE;
			return resolve();
		}
		// check if the customer has unique email  	
		this._emailService.FindEmail(this._userService.customerid, this.user.contacts.email)
			.then((res: IIsExistedResponse) => {
				if (res.exist)
					return reject({ type: "message", title: "E-mail", content: this.replaceWith(this.alerts.alert_3, this.user.contacts.email), btn: 'X' })
				else
					// check if the customer has valid email address	
					this._emailService.VerifyEmail(this.user.contacts.email)
						.then((data: IIsExistedResponse) => {
							if (data.exist) {
								this.user.contacts.emailStatus = Status.Verified;
								return resolve();
							} else {
								this.user.contacts.emailStatus = Status.Invalid;
								return reject({ type: "message", title: this.Labels.invalid, content: this.replaceWith(this.alerts.alert_7, this.user.contacts.email), btn: 'X' })
							}
						})
						.catch(() => {
							this.user.contacts.emailStatus = Status.Unchecked;
							return resolve();
						})
			})
			.catch(() => {
				if (this.source == 'app') {
					//console.log("chiamata script KO FindEmail");
					self.postMessage(JSON.stringify({ "type": "KO", payload: { "username": "", "password": "", "message": this.alerts.alert_32 } }), '*');
				}
				return reject({ type: "SERVER", title: "SERVER", content: this.alerts.alert_32, btn: this.Labels.cancel });
			})
	}

	verifyPhone(resolve, reject) {
		//	console.log("verifyPhone");

		var phone = this.phonePrefix + this.user.contacts.cellulare;
		// check if the customer has valid phone number	
		this._customerService.VerifyPhoneNumber(phone)
			.then((data: IIsExistedResponse) => {
				if (data.exist) {
					this.user.contacts.cellulareStatus = Status.Verified;
					return resolve();
				} else {
					this.user.contacts.cellulareStatus = Status.Invalid;
					return reject({ type: "message", title: this.Labels.invalid, content: this.replaceWith(this.alerts.alert_6, phone), btn: 'X' })
				}
			})
			.catch(() => {
				this.user.contacts.cellulareStatus = Status.Unchecked;
				return resolve();
			})
	}
}


// WEBPACK FOOTER //
// ./src/app/theme/components/slide1/slide1.component.ts